import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

const BASE = `${process.env.REACT_APP_BASE_URL}/messages`;

export const fetchBellNotifications = () =>
  axios.get(`${BASE}/bell`, { headers: authHeader() }).then((res) => res.data.data);

export const markBellSeen = () =>
  axios.post(`${BASE}/bell/mark-seen`, {}, { headers: authHeader() }).then((res) => res.data);

export const fetchCompanyUsers = () =>
  axios.get(`${BASE}/users`, { headers: authHeader() }).then((res) => res.data.data);

export const fetchAllMessages = (params = {}) =>
  axios.get(BASE, { headers: authHeader(), params }).then((res) => res.data.data);

export const fetchMessageDetail = (id) =>
  axios.get(`${BASE}/${id}`, { headers: authHeader() }).then((res) => res.data.data);

export const createMessage = (data) =>
  new Promise((resolve, reject) =>
    axios
      .post(BASE, data, { headers: authHeader() })
      .then((res) => { toast.success(res.data.msg); resolve(res.data.data); })
      .catch((err) => { if (err?.response?.data?.msg) toast.error(err.response.data.msg); reject(err); })
  );

export const replyMessage = (id, data) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${BASE}/${id}/reply`, data, { headers: authHeader() })
      .then((res) => { toast.success(res.data.msg); resolve(res.data.data); })
      .catch((err) => { if (err?.response?.data?.msg) toast.error(err.response.data.msg); reject(err); })
  );

export const toggleMessageStatus = (id) =>
  new Promise((resolve, reject) =>
    axios
      .put(`${BASE}/${id}/toggle`, {}, { headers: authHeader() })
      .then((res) => { toast.success(res.data.msg); resolve(res.data.data); })
      .catch((err) => { if (err?.response?.data?.msg) toast.error(err.response.data.msg); reject(err); })
  );
